module.exports = __webpack_public_path__ + "static/img/264_TO8_2347.17a4cc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/264_TO8_2347.jpg
// module id = Nhfl
// module chunks = 0